export default __webpack_public_path__ + "static/headerbig-c924aa750fb5a061060420190aa14039.jpg";